"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var core_1 = require("@material-ui/core");
var colorsV2_1 = __importDefault(require("../../assets/jss/colorsV2"));
var styles = function (theme, isNewVersion, isMobile) {
    var _a, _b, _c, _d, _e, _f;
    var _g, _h, _j;
    return (0, core_1.makeStyles)({
        inputTitle: {
            color: isNewVersion ? theme.palette.text.secondary : theme.palette.grey[700]
        },
        inputTitleUpdated: {
            marginTop: '34px',
            marginLeft: '12px'
        },
        inputLabel: __assign(__assign({ marginTop: '40px' }, theme.typography.h3), { color: theme.palette.grey[700] }),
        nobgContainer: (_a = {},
            _a[theme.breakpoints.down('sm')] = {
                width: '100%'
            },
            _a.backgroundColor = 'transparent',
            _a),
        numbersContainer: {
            margin: '5rem auto',
            width: '100%',
            backgroundColor: theme.palette.background.default,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        formContainer: (_b = {
                padding: isNewVersion ? '40px 0px' : '40px 16px',
                maxWidth: '625px'
            },
            _b[theme.breakpoints.up('md')] = {
                minWidth: '625px'
            },
            _b[theme.breakpoints.down('sm')] = {
                padding: isNewVersion ? '10px 0px' : '10px'
            },
            _b),
        upToTen: {
            fontSize: '18px',
            display: 'block'
        },
        configContainer: {
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column'
        },
        btnContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        button: {
            display: 'block',
            margin: '16px 0',
            padding: '16px 30px',
            background: theme.palette.primary.main,
            '&:focus, &:hover, &:active': {
                background: theme.palette.primary.main
            },
            '& span': {
                color: theme.palette.primary.contrastText
            }
        },
        btnTransform: {
            padding: '12px',
            '& span': {
                textTransform: 'none'
            }
        },
        buttonOutline: {
            display: 'block',
            margin: '16px 0',
            padding: '4px 8px',
            border: "2px solid ".concat(theme.palette.primary.main, " !important"),
            '& span': {
                textTransform: 'none'
            }
        },
        btnDisabled: {
            borderColor: "".concat(theme.palette.grey[300], " !important"),
            '& span': {
                color: "".concat(theme.palette.grey[300])
            }
        },
        checkBtn: {
            background: theme.palette.secondary.main,
            '&:focus, &:hover, &:active': {
                background: theme.palette.secondary.main
            },
            '& span': {
                color: theme.palette.secondary.contrastText
            },
            '@media (hover: none)': {
                backgroundColor: "".concat(theme.palette.secondary.main, " !important")
            }
        },
        errorsContainer: {
            width: '100%',
            marginTop: '40px',
            padding: '16px',
            background: theme.palette.error.light,
            border: "1px solid ".concat(theme.palette.grey[500])
        },
        errorsNewContainer: {
            width: '100%',
            marginTop: '40px',
            padding: '16px',
            background: theme.palette.error.contrastText,
            border: "1px solid ".concat(theme.palette.grey[500])
        },
        errorText: {
            color: theme.palette.error.main,
            fontSize: '16px'
        },
        selectInput: {
            width: '100%',
            margin: '8px 0',
            backgroundColor: theme.palette.background.paper,
            border: "1px solid ".concat(theme.palette.grey[700]),
            padding: '8px 16px',
            '& .MuiSelect-root:focus': {
                backgroundColor: theme.palette.background.paper
            }
        },
        dateInput: {
            borderRadius: '8px'
        },
        selectInputUpdated: {
            width: '100%',
            margin: '8px 0',
            borderRadius: '8px',
            backgroundColor: theme.palette.background.paper,
            border: "1px solid ".concat(theme.palette.grey[500]),
            padding: '8px 16px',
            '& .MuiSelect-root:focus': {
                backgroundColor: theme.palette.background.paper
            }
        },
        ticketContainer: {
            margin: isNewVersion ? theme.spacing(4, 0) : theme.spacing(2, 0),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexWrap: 'wrap'
        },
        ticketContainerSpace: {
            margin: theme.spacing(2, 0, 2, 0),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexWrap: 'wrap'
        },
        checkBoxLabel: {
            marginTop: '62px'
        },
        numberInput: (_c = {
                width: '52px',
                height: '48px',
                marginRight: '16px',
                backgroundColor: theme.palette.background.paper,
                border: "1px solid ".concat(theme.palette.grey[700]),
                padding: '8px',
                textAlign: 'center'
            },
            _c[theme.breakpoints.down('xs')] = {
                width: '44px',
                height: '40px',
                marginRight: '4px'
            },
            _c['& input:focus'] = {
                boxShadow: 'none',
                border: 'none',
                backgroundColor: 'none'
            },
            _c),
        numberInputUpdated: {
            borderRadius: '8px',
            border: "1px solid ".concat(theme.palette.grey[500])
        },
        raffleInput: {
            width: '90px',
            display: 'block',
            margin: '24px 0'
        },
        specialNumber: {
            backgroundColor: theme.palette.error.light
        },
        sectionTitle: {
            color: theme.palette.grey[700],
            textAlign: 'center'
        },
        resultsLegend: {
            color: theme.palette.grey[700],
            textAlign: 'left'
        },
        sectionUpdatedTitle: {
            marginTop: '24px',
            textAlign: 'center'
        },
        resultLegend: {
            margin: '40px 0 16px',
            color: theme.palette.grey[700]
        },
        legendContainer: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'baseline',
            margin: '16px 0'
        },
        ball: {
            display: 'inline-block',
            width: '32px',
            height: '32px',
            marginRight: '8px',
            color: theme.palette.grey[600],
            backgroundColor: theme.palette.background.paper,
            borderRadius: '16px',
            border: "1px solid ".concat(theme.palette.grey[400]),
            textAlign: 'center',
            lineHeight: '2rem',
            fontSize: '14px',
            boxShadow: "0 2px 0 0 ".concat(theme.palette.grey[400])
        },
        maching: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            border: "1px solid ".concat(theme.palette.primary.dark),
            boxShadow: "0 2px 0 0 ".concat(theme.palette.primary.dark)
        },
        machingNew: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            border: "1px solid ".concat(theme.palette.primary.dark),
            boxShadow: "0 2px 0 0 ".concat(theme.palette.primary.dark)
        },
        special: {
            color: theme.palette.error.main,
            border: "1px solid ".concat(theme.palette.error.dark),
            boxShadow: "0 2px 0 0 ".concat(theme.palette.error.dark)
        },
        machingSpecial: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.background.paper
        },
        machingSpecialNew: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.background.paper
        },
        resultContainer: (_d = {
                backgroundColor: theme.palette.background.paper,
                padding: '24px'
            },
            _d[theme.breakpoints.down('sm')] = {
                padding: '0px'
            },
            _d.display = 'flex',
            _d.flexDirection = 'column',
            _d.justifyContent = 'flex-start',
            _d.marginBottom = '32px',
            _d),
        winningResultContainer: (_e = {
                backgroundColor: theme.palette.background.default,
                padding: '24px'
            },
            _e[theme.breakpoints.down('sm')] = {
                padding: '0px'
            },
            _e.display = 'flex',
            _e.flexDirection = 'column',
            _e.justifyContent = 'flex-start',
            _e.marginBottom = '32px',
            _e),
        drawDate: {
            color: theme.palette.grey[700],
            textAlign: 'center'
        },
        numberContainer: {
            margin: '16px 0 32px',
            backgroundColor: theme.palette.background.default,
            padding: '8px',
            width: '100%',
            display: 'flex',
            textAlign: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        },
        winningNumbers: {
            display: 'flex',
            textAlign: 'center',
            flexDirection: 'row',
            justifyContent: 'center',
            marginBottom: theme.spacing(2)
        },
        winningNumberContainer: {
            margin: '16px 0 32px',
            backgroundColor: theme.palette.background.default,
            padding: theme.spacing(1),
            width: '100%',
            display: 'flex',
            textAlign: 'center',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center'
        },
        playersTicket: {
            border: "1px solid ".concat(theme.palette.grey[400]),
            padding: '0 16px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginBottom: '24px'
        },
        resultsContainer: {
            border: "1px solid ".concat(theme.palette.grey[400]),
            padding: '0 16px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column'
        },
        blankGrid: {
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column'
        },
        ticketText: {
            color: theme.palette.grey[700],
            textAlign: 'center',
            margin: '16px 0',
            fontSize: '18px'
        },
        ticketLabels: {
            paddingBottom: theme.spacing(2)
        },
        betType: {
            marginTop: theme.spacing(2),
            width: '100%',
            paddingBottom: theme.spacing()
        },
        selectInputLabel: {
            position: 'static',
            transform: 'none',
            fontSize: '16px',
            paddingLeft: theme.spacing(2)
        },
        inputLabelError: {
            color: (_g = colorsV2_1.default.commonColors.error) === null || _g === void 0 ? void 0 : _g.hex(),
            position: 'static',
            transform: 'none',
            fontSize: '16px',
            textAlign: 'left',
            marginLeft: '12px',
            marginBottom: theme.spacing()
        },
        indexLabelError: {
            color: (_h = colorsV2_1.default.commonColors.error) === null || _h === void 0 ? void 0 : _h.hex(),
            position: 'static',
            transform: 'none',
            fontSize: '16px',
            textAlign: 'left',
            marginLeft: '12px'
        },
        numberErrorInput: {
            border: "2px solid ".concat(theme.palette.error.main),
            textAlign: 'center'
        },
        indexLabel: {
            position: 'static',
            transform: 'none',
            fontSize: '16px',
            textAlign: 'center',
            marginLeft: '12px',
            marginBottom: theme.spacing()
        },
        indexLabelUpdated: {
            position: 'static',
            transform: 'none',
            fontSize: '16px',
            textAlign: 'left',
            marginLeft: '12px'
        },
        iconLabelError: {
            color: (_j = colorsV2_1.default.commonColors.error) === null || _j === void 0 ? void 0 : _j.hex(),
            position: 'static',
            transform: 'none',
            fontSize: '16px'
        },
        errorContainer: {
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
            alignItems: 'center',
            marginLeft: isNewVersion ? '12px' : '0px'
        },
        winningAmount: {
            color: theme.palette.primary.main
        },
        multiplier: {
            textAlign: 'center',
            marginBottom: '16px'
        },
        centerText: {
            textAlign: 'center'
        },
        gameImg: (_f = {
                width: '238px',
                display: 'flex',
                margin: '0 auto'
            },
            _f[theme.breakpoints.down('sm')] = {
                width: '216px'
            },
            _f[theme.breakpoints.down('xs')] = {
                width: '160px'
            },
            _f),
        captionTxt: {
            marginTop: '24px',
            display: 'block'
        },
        srOnly: {
            position: 'absolute',
            width: '1px',
            height: '1px',
            margin: '-1px',
            padding: 0,
            border: 0,
            clip: 'rect(0, 0, 0, 0)',
            overflow: 'hidden'
        }
    });
};
exports.styles = styles;
//# sourceMappingURL=styles.js.map